import { HTTPError } from 'ky';

export const errorMessage = async (error: unknown) => {
  if (error instanceof HTTPError) {
    try {
      const body = await error.response.json<{
        message?: string;
        data?: { businessMessage?: string };
      }>();
      return body.data?.businessMessage ?? body.message ?? 'Unable to continue. Please retry.';
    } catch {
      return '服务暂不可用，请重试 / Service unavailable. Please retry.';
    }
  }
  return '服务暂不可用，请重试 / Service unavailable. Please retry.';
};
